export const Layout = ({ children }) => (
  <div className="px-[18px] pb-[50px] xl:container xl:mx-auto xl:pb-[300px] 2xl:px-[128px]">
    {children}
  </div>
);
